import React from 'react';
import PropTypes from 'prop-types';
import FolderListItem from './FolderListItem';
import { FolderListWrapper } from './FolderListStyles';

const FolderList = ({ folders, fieldsToShow, onEdit }) => {
  return (
    <FolderListWrapper container>
      {folders.map(n => {
        return <FolderListItem key={n.documentId} item={n} internalOnEdit={onEdit} fieldsToShow={fieldsToShow} />;
      })}
    </FolderListWrapper>
  );
};

FolderList.propTypes = {
  folders: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  fieldsToShow: PropTypes.array.isRequired
};

export default FolderList;
